export default __webpack_public_path__ + "static/media/3.5d178513.jpg";